module.exports = __webpack_public_path__ + "img/logo.544d98fb.png";